<template>
  <div class="item-container">
    <div
      class="item-main"
      :class="{ 'item-active': dropdown }"
      @click="toggleExpand"
      :id="`itemexpander-${item.jsonid}`"
    >
      <div class="item-title">
        <i class="icon-travel_insurance_light glyph-lg pr-3" />
        <span>{{ item.title.toUpperCase() }}</span>
      </div>
      <!-- This will be hidden on mobile devices -->
      <div class="item-main-desktop">
        <h6>{{ item.duration }}</h6>
        <h6>{{ item.area }}</h6>
      </div>
      <!-- This will be hidden on mobile devices -->
      <div class="item-main-desktop">
        <h6>Commencing on {{ item.startdate }}</h6>
      </div>
      <div class="toggle">
        <span v-if="!dropdown">+</span>
        <span v-else>-</span>
      </div>
    </div>
    <div v-if="dropdown" class="item-dropdown">
      <div class="item-dropdown-main">
        <ul>
          <li v-if="item.startdate" class="mobile-dropdown-item">
            <h4>Commencing on</h4>
            <p>{{ item.startdate }}</p>
          </li>
          <li v-if="item.insurancefor">
            <h4>Insurance for</h4>
            <p>{{ item.insurancefor }}</p>
          </li>
          <li v-if="item.area">
            <h4>Area</h4>
            <p>{{ item.area }}</p>
          </li>
          <li v-if="item.bookdate">
            <h4>Taken out on</h4>
            <p>{{ item.bookdate }}</p>
          </li>
          <li v-if="item.quoteamount">
            <h4>Quote</h4>
            <p>{{ item.quoteamount }}</p>
          </li>
          <li v-if="item.status">
            <h4>Status</h4>
            <p>{{ item.status }}</p>
          </li>
        </ul>
        <div class="extra-info" />
      </div>
      <div class="insurance-details">
        <topuptext />
        <button
          v-for="(link, index) in insLinks"
          class="ins-btns optional-ins-btns"
          :key="index"
          @click="
            () => {
              openLink(link.link);
            }
          "
        >
          <i class="material-icons vtd-mr-3">picture_as_pdf</i>
          <span>{{ link.title }}</span>
        </button>
        <button
          class="ins-btns optional-ins-btns"
          @click="() => openLink(ipidHref)"
        >
          Insurance Product Information Document
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import topuptext from "./insurance-topup-text";
import { mapGetters } from "vuex";

export default {
  components: {
    topuptext,
  },
  props: {
    item: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      dropdown: true,
      ipidHref: ''
    };
  },
  mounted() {
    this.$root.$on("collapseall", () => {
      this.collapseAll();
    });
    this.$root.$on("expandall", () => {
      this.expandAll();
    });
    this.getIPIDHref()
  },
  computed: {
    insLinks() {
      if (!this.item || !this.item.inslinks) return null;
      return this.item.inslinks.filter((link) => link.title && link.link);
    },
    ...mapGetters({
      essentialInfoMenu: "essentialInfoMenu/getMenu",
    }),
  },
  methods: {
    collapseAll() {
      this.dropdown = false;
    },
    expandAll() {
      this.dropdown = true;
    },
    insLinkClick(link) {
      window.open(link, "_blank");
    },
    toggleExpand() {
      this.dropdown = !this.dropdown;
    },
    openLink(link) {
      window.open(link);
    },
    getIPIDHref() {
      const insObj = this.essentialInfoMenu && this.essentialInfoMenu.find((item) => item.title === 'Travel Insurance')
      const ipidItem = insObj && insObj.submenu && insObj.submenu.find((item) => item.title === 'IPID')
      this.ipidHref = ipidItem ? ipidItem.href : ''
    },
  },
};
</script>

<style lang="scss">
@import "../styles";
.optional-ins-btns {
  margin-top: 10px !important;
}
</style>
